// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: 'Montserrat', sans-serif;
}

/* TOASTS */
.Toastify__toast-container {
    z-index: 9999;
    transform: translate3d(0, 0, 9999px);
    -webkit-transform: translate3d(0, 0, 9999px);
    position: fixed;
    padding: 4px;
    width: 320px;
    box-sizing: border-box;
    color: #fff;
  }
  .Toastify__toast-container--top-left {
    top: 1em;
    left: 1em;
  }
  .Toastify__toast-container--top-center {
    top: 1em;
    left: 50%;
    transform: translateX(-50%);
  }
  .Toastify__toast-container--top-right {
    top: 100px;
    right: 1em;
  }
  .Toastify__toast-container--bottom-left {
    bottom: 1em;
    left: 1em;
  }
  .Toastify__toast-container--bottom-center {
    bottom: 1em;
    left: 50%;
    transform: translateX(-50%);
  }
  .Toastify__toast-container--bottom-right {
    bottom: 1em;
    right: 1em;
  }

  @media only screen and (max-width : 480px) {
    .Toastify__toast-container {
      width: 100vw;
      padding: 0;
      left: 0;
      margin: 0;
      z-index: 20000;
    }
    .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
      top: 0;
      transform: translateX(0);
    }
    .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
      bottom: 0;
      transform: translateX(0);
    }
    .Toastify__toast-container--rtl {
      right: 0;
      left: initial;
    }
  }
  .Toastify__toast {
    position: relative;
    min-height: 64px;
    box-sizing: border-box;
    margin-bottom: 1rem;
    padding: 8px;
    border-radius: 4px;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    max-height: 800px;
    overflow: hidden;
    font-family: sans-serif;
    cursor: pointer;
    direction: ltr;
  }
  .Toastify__toast--rtl {
    direction: rtl;
  }
  .Toastify__toast--dark {
    background: #121212;
    color: #fff;
  }
  .Toastify__toast--default {
    background: #fff;
    color: #aaa;
  }
  /* .Toastify__toast--info {
    background: #3498db;
  }
  .Toastify__toast--success {
    background: #07bc0c;
  }
  .Toastify__toast--warning {
    background: #f1c40f;
  }
  .Toastify__toast--error {
    background: #e74c3c;
  } */
  .Toastify__toast-body {
    margin: auto 0;
    padding: 6px;
  }

  .Toastify--animate {
    animation-fill-mode: both;
    animation-duration: 0.7s;
  }

  @media only screen and (max-width : 480px) {
    .Toastify__toast {
      margin-bottom: 0;
    }
  }
  .Toastify__close-button {
    color: #fff;
    background: transparent;
    outline: none;
    border: none;
    padding: 0;
    cursor: pointer;
    opacity: 0.7;
    transition: 0.3s ease;
    align-self: flex-start;
  }
  .Toastify__close-button--default {
    color: #000;
    opacity: 0.3;
  }
  .Toastify__close-button > svg {
    fill: currentColor;
    height: 16px;
    width: 14px;
  }
  .Toastify__close-button:hover, .Toastify__close-button:focus {
    opacity: 1;
  }

  @keyframes Toastify__trackProgress {
    0% {
      transform: scaleX(1);
    }
    100% {
      transform: scaleX(0);
    }
  }
  .Toastify__progress-bar {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 5px;
    z-index: 9999;
    opacity: 0.7;
    background-color: rgba(255, 255, 255, 0.7);
    transform-origin: left;
  }
  .Toastify__progress-bar--animated {
    animation: Toastify__trackProgress linear 1 forwards;
  }
  .Toastify__progress-bar--controlled {
    transition: transform 0.2s;
  }
  .Toastify__progress-bar--rtl {
    right: 0;
    left: initial;
    transform-origin: right;
  }
  .Toastify__progress-bar--default {
    background: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  }
  .Toastify__progress-bar--dark {
    background: #bb86fc;
  }
  @keyframes Toastify__bounceInRight {
    from, 60%, 75%, 90%, to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0);
    }
    75% {
      transform: translate3d(10px, 0, 0);
    }
    90% {
      transform: translate3d(-5px, 0, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutRight {
    20% {
      opacity: 1;
      transform: translate3d(-20px, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(2000px, 0, 0);
    }
  }
  @keyframes Toastify__bounceInLeft {
    from, 60%, 75%, 90%, to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(-3000px, 0, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(25px, 0, 0);
    }
    75% {
      transform: translate3d(-10px, 0, 0);
    }
    90% {
      transform: translate3d(5px, 0, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutLeft {
    20% {
      opacity: 1;
      transform: translate3d(20px, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(-2000px, 0, 0);
    }
  }
  @keyframes Toastify__bounceInUp {
    from, 60%, 75%, 90%, to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    from {
      opacity: 0;
      transform: translate3d(0, 3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }
    75% {
      transform: translate3d(0, 10px, 0);
    }
    90% {
      transform: translate3d(0, -5px, 0);
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0);
    }
    40%, 45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0);
    }
  }
  @keyframes Toastify__bounceInDown {
    from, 60%, 75%, 90%, to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    }
    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0);
    }
    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0);
    }
    75% {
      transform: translate3d(0, -10px, 0);
    }
    90% {
      transform: translate3d(0, 5px, 0);
    }
    to {
      transform: none;
    }
  }
  @keyframes Toastify__bounceOutDown {
    20% {
      transform: translate3d(0, 10px, 0);
    }
    40%, 45% {
      opacity: 1;
      transform: translate3d(0, -20px, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, 2000px, 0);
    }
  }
  .Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
    animation-name: Toastify__bounceInLeft;
  }
  .Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
    animation-name: Toastify__bounceInRight;
  }
  .Toastify__bounce-enter--top-center {
    animation-name: Toastify__bounceInDown;
  }
  .Toastify__bounce-enter--bottom-center {
    animation-name: Toastify__bounceInUp;
  }

  .Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
    animation-name: Toastify__bounceOutLeft;
  }
  .Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
    animation-name: Toastify__bounceOutRight;
  }
  .Toastify__bounce-exit--top-center {
    animation-name: Toastify__bounceOutUp;
  }
  .Toastify__bounce-exit--bottom-center {
    animation-name: Toastify__bounceOutDown;
  }

  @keyframes Toastify__zoomIn {
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    50% {
      opacity: 1;
    }
  }
  @keyframes Toastify__zoomOut {
    from {
      opacity: 1;
    }
    50% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3);
    }
    to {
      opacity: 0;
    }
  }
  .Toastify__zoom-enter {
    animation-name: Toastify__zoomIn;
  }

  .Toastify__zoom-exit {
    animation-name: Toastify__zoomOut;
  }

  @keyframes Toastify__flipIn {
    from {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      animation-timing-function: ease-in;
      opacity: 0;
    }
    40% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      animation-timing-function: ease-in;
    }
    60% {
      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
      opacity: 1;
    }
    80% {
      transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    }
    to {
      transform: perspective(400px);
    }
  }
  @keyframes Toastify__flipOut {
    from {
      transform: perspective(400px);
    }
    30% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      opacity: 1;
    }
    to {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      opacity: 0;
    }
  }
  .Toastify__flip-enter {
    animation-name: Toastify__flipIn;
  }

  .Toastify__flip-exit {
    animation-name: Toastify__flipOut;
  }

  @keyframes Toastify__slideInRight {
    from {
      transform: translate3d(110%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideInLeft {
    from {
      transform: translate3d(-110%, 0, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideInUp {
    from {
      transform: translate3d(0, 110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideInDown {
    from {
      transform: translate3d(0, -110%, 0);
      visibility: visible;
    }
    to {
      transform: translate3d(0, 0, 0);
    }
  }
  @keyframes Toastify__slideOutRight {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(110%, 0, 0);
    }
  }
  @keyframes Toastify__slideOutLeft {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(-110%, 0, 0);
    }
  }
  @keyframes Toastify__slideOutDown {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, 500px, 0);
    }
  }
  @keyframes Toastify__slideOutUp {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      visibility: hidden;
      transform: translate3d(0, -500px, 0);
    }
  }
  .Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
    animation-name: Toastify__slideInLeft;
  }
  .Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
    animation-name: Toastify__slideInRight;
  }
  .Toastify__slide-enter--top-center {
    animation-name: Toastify__slideInDown;
  }
  .Toastify__slide-enter--bottom-center {
    animation-name: Toastify__slideInUp;
  }

  .Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
    animation-name: Toastify__slideOutLeft;
  }
  .Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
    animation-name: Toastify__slideOutRight;
  }
  .Toastify__slide-exit--top-center {
    animation-name: Toastify__slideOutUp;
  }
  .Toastify__slide-exit--bottom-center {
    animation-name: Toastify__slideOutDown;
  }

  /*# sourceMappingURL=ReactToastify.css.map */

.Toastify__toast--info {
    background: #8560FF;
    color: #ffffff;
}
.Toastify__toast--success {
    background: #41C6A2;
}
.Toastify__toast--warning {
    background: #F7C76C;
}
.Toastify__toast--error {
    background: #FF6969;
}



.loadingPage{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 25%;
}

.versioning {
  position: absolute;
  font-size: 8px;
  right: 0;
  color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;AACzC;;AAEA,WAAW;AACX;IACI,aAAa;IACb,oCAAoC;IACpC,4CAA4C;IAC5C,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,QAAQ;IACR,SAAS;EACX;EACA;IACE,QAAQ;IACR,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,WAAW;IACX,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE;MACE,YAAY;MACZ,UAAU;MACV,OAAO;MACP,SAAS;MACT,cAAc;IAChB;IACA;MACE,MAAM;MACN,wBAAwB;IAC1B;IACA;MACE,SAAS;MACT,wBAAwB;IAC1B;IACA;MACE,QAAQ;MACR,aAAa;IACf;EACF;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,6EAA6E;IAE7E,aAAa;IAET,8BAA8B;IAClC,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;;;;;;;;;;;KAWG;EACH;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,eAAe;IACf,YAAY;IACZ,qBAAqB;IAEjB,sBAAsB;EAC5B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;EACb;EACA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,oBAAoB;IACtB;IACA;MACE,oBAAoB;IACtB;EACF;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,WAAW;IACX,aAAa;IACb,YAAY;IACZ,0CAA0C;IAC1C,sBAAsB;EACxB;EACA;IACE,oDAAoD;EACtD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,QAAQ;IACR,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,2FAA2F;EAC7F;EACA;IACE,mBAAmB;EACrB;EACA;IACE;MACE,8DAA8D;IAChE;IACA;MACE,UAAU;MACV,oCAAoC;IACtC;IACA;MACE,UAAU;MACV,mCAAmC;IACrC;IACA;MACE,kCAAkC;IACpC;IACA;MACE,kCAAkC;IACpC;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,UAAU;MACV,mCAAmC;IACrC;IACA;MACE,UAAU;MACV,oCAAoC;IACtC;EACF;EACA;IACE;MACE,8DAA8D;IAChE;IACA;MACE,UAAU;MACV,qCAAqC;IACvC;IACA;MACE,UAAU;MACV,kCAAkC;IACpC;IACA;MACE,mCAAmC;IACrC;IACA;MACE,iCAAiC;IACnC;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,UAAU;MACV,kCAAkC;IACpC;IACA;MACE,UAAU;MACV,qCAAqC;IACvC;EACF;EACA;IACE;MACE,8DAA8D;IAChE;IACA;MACE,UAAU;MACV,oCAAoC;IACtC;IACA;MACE,UAAU;MACV,mCAAmC;IACrC;IACA;MACE,kCAAkC;IACpC;IACA;MACE,kCAAkC;IACpC;IACA;MACE,+BAA+B;IACjC;EACF;EACA;IACE;MACE,mCAAmC;IACrC;IACA;MACE,UAAU;MACV,kCAAkC;IACpC;IACA;MACE,UAAU;MACV,qCAAqC;IACvC;EACF;EACA;IACE;MACE,8DAA8D;IAChE;IACA;MACE,UAAU;MACV,qCAAqC;IACvC;IACA;MACE,UAAU;MACV,kCAAkC;IACpC;IACA;MACE,mCAAmC;IACrC;IACA;MACE,iCAAiC;IACnC;IACA;MACE,eAAe;IACjB;EACF;EACA;IACE;MACE,kCAAkC;IACpC;IACA;MACE,UAAU;MACV,mCAAmC;IACrC;IACA;MACE,UAAU;MACV,oCAAoC;IACtC;EACF;EACA;IACE,sCAAsC;EACxC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,oCAAoC;EACtC;;EAEA;IACE,uCAAuC;EACzC;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,qCAAqC;EACvC;EACA;IACE,uCAAuC;EACzC;;EAEA;IACE;MACE,UAAU;MACV,iCAAiC;IACnC;IACA;MACE,UAAU;IACZ;EACF;EACA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;MACV,iCAAiC;IACnC;IACA;MACE,UAAU;IACZ;EACF;EACA;IACE,gCAAgC;EAClC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE;MACE,sDAAsD;MACtD,kCAAkC;MAClC,UAAU;IACZ;IACA;MACE,uDAAuD;MACvD,kCAAkC;IACpC;IACA;MACE,sDAAsD;MACtD,UAAU;IACZ;IACA;MACE,sDAAsD;IACxD;IACA;MACE,6BAA6B;IAC/B;EACF;EACA;IACE;MACE,6BAA6B;IAC/B;IACA;MACE,uDAAuD;MACvD,UAAU;IACZ;IACA;MACE,sDAAsD;MACtD,UAAU;IACZ;EACF;EACA;IACE,gCAAgC;EAClC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE;MACE,kCAAkC;MAClC,mBAAmB;IACrB;IACA;MACE,+BAA+B;IACjC;EACF;EACA;IACE;MACE,mCAAmC;MACnC,mBAAmB;IACrB;IACA;MACE,+BAA+B;IACjC;EACF;EACA;IACE;MACE,kCAAkC;MAClC,mBAAmB;IACrB;IACA;MACE,+BAA+B;IACjC;EACF;EACA;IACE;MACE,mCAAmC;MACnC,mBAAmB;IACrB;IACA;MACE,+BAA+B;IACjC;EACF;EACA;IACE;MACE,+BAA+B;IACjC;IACA;MACE,kBAAkB;MAClB,kCAAkC;IACpC;EACF;EACA;IACE;MACE,+BAA+B;IACjC;IACA;MACE,kBAAkB;MAClB,mCAAmC;IACrC;EACF;EACA;IACE;MACE,+BAA+B;IACjC;IACA;MACE,kBAAkB;MAClB,mCAAmC;IACrC;EACF;EACA;IACE;MACE,+BAA+B;IACjC;IACA;MACE,kBAAkB;MAClB,oCAAoC;IACtC;EACF;EACA;IACE,qCAAqC;EACvC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,mCAAmC;EACrC;;EAEA;IACE,sCAAsC;EACxC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,oCAAoC;EACtC;EACA;IACE,sCAAsC;EACxC;;EAEA,4CAA4C;;AAE9C;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;;;AAIA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,kBAAkB;AACpB","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    font-family: 'Montserrat', sans-serif;\n}\n\n/* TOASTS */\n.Toastify__toast-container {\n    z-index: 9999;\n    transform: translate3d(0, 0, 9999px);\n    -webkit-transform: translate3d(0, 0, 9999px);\n    position: fixed;\n    padding: 4px;\n    width: 320px;\n    box-sizing: border-box;\n    color: #fff;\n  }\n  .Toastify__toast-container--top-left {\n    top: 1em;\n    left: 1em;\n  }\n  .Toastify__toast-container--top-center {\n    top: 1em;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  .Toastify__toast-container--top-right {\n    top: 100px;\n    right: 1em;\n  }\n  .Toastify__toast-container--bottom-left {\n    bottom: 1em;\n    left: 1em;\n  }\n  .Toastify__toast-container--bottom-center {\n    bottom: 1em;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  .Toastify__toast-container--bottom-right {\n    bottom: 1em;\n    right: 1em;\n  }\n\n  @media only screen and (max-width : 480px) {\n    .Toastify__toast-container {\n      width: 100vw;\n      padding: 0;\n      left: 0;\n      margin: 0;\n      z-index: 20000;\n    }\n    .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {\n      top: 0;\n      transform: translateX(0);\n    }\n    .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {\n      bottom: 0;\n      transform: translateX(0);\n    }\n    .Toastify__toast-container--rtl {\n      right: 0;\n      left: initial;\n    }\n  }\n  .Toastify__toast {\n    position: relative;\n    min-height: 64px;\n    box-sizing: border-box;\n    margin-bottom: 1rem;\n    padding: 8px;\n    border-radius: 4px;\n    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    max-height: 800px;\n    overflow: hidden;\n    font-family: sans-serif;\n    cursor: pointer;\n    direction: ltr;\n  }\n  .Toastify__toast--rtl {\n    direction: rtl;\n  }\n  .Toastify__toast--dark {\n    background: #121212;\n    color: #fff;\n  }\n  .Toastify__toast--default {\n    background: #fff;\n    color: #aaa;\n  }\n  /* .Toastify__toast--info {\n    background: #3498db;\n  }\n  .Toastify__toast--success {\n    background: #07bc0c;\n  }\n  .Toastify__toast--warning {\n    background: #f1c40f;\n  }\n  .Toastify__toast--error {\n    background: #e74c3c;\n  } */\n  .Toastify__toast-body {\n    margin: auto 0;\n    padding: 6px;\n  }\n\n  .Toastify--animate {\n    animation-fill-mode: both;\n    animation-duration: 0.7s;\n  }\n\n  @media only screen and (max-width : 480px) {\n    .Toastify__toast {\n      margin-bottom: 0;\n    }\n  }\n  .Toastify__close-button {\n    color: #fff;\n    background: transparent;\n    outline: none;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    opacity: 0.7;\n    transition: 0.3s ease;\n    -ms-flex-item-align: start;\n        align-self: flex-start;\n  }\n  .Toastify__close-button--default {\n    color: #000;\n    opacity: 0.3;\n  }\n  .Toastify__close-button > svg {\n    fill: currentColor;\n    height: 16px;\n    width: 14px;\n  }\n  .Toastify__close-button:hover, .Toastify__close-button:focus {\n    opacity: 1;\n  }\n\n  @keyframes Toastify__trackProgress {\n    0% {\n      transform: scaleX(1);\n    }\n    100% {\n      transform: scaleX(0);\n    }\n  }\n  .Toastify__progress-bar {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 5px;\n    z-index: 9999;\n    opacity: 0.7;\n    background-color: rgba(255, 255, 255, 0.7);\n    transform-origin: left;\n  }\n  .Toastify__progress-bar--animated {\n    animation: Toastify__trackProgress linear 1 forwards;\n  }\n  .Toastify__progress-bar--controlled {\n    transition: transform 0.2s;\n  }\n  .Toastify__progress-bar--rtl {\n    right: 0;\n    left: initial;\n    transform-origin: right;\n  }\n  .Toastify__progress-bar--default {\n    background: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);\n  }\n  .Toastify__progress-bar--dark {\n    background: #bb86fc;\n  }\n  @keyframes Toastify__bounceInRight {\n    from, 60%, 75%, 90%, to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    from {\n      opacity: 0;\n      transform: translate3d(3000px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(-25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(-5px, 0, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n  @keyframes Toastify__bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translate3d(-20px, 0, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(2000px, 0, 0);\n    }\n  }\n  @keyframes Toastify__bounceInLeft {\n    from, 60%, 75%, 90%, to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(-3000px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(-10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(5px, 0, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n  @keyframes Toastify__bounceOutLeft {\n    20% {\n      opacity: 1;\n      transform: translate3d(20px, 0, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(-2000px, 0, 0);\n    }\n  }\n  @keyframes Toastify__bounceInUp {\n    from, 60%, 75%, 90%, to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    from {\n      opacity: 0;\n      transform: translate3d(0, 3000px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    75% {\n      transform: translate3d(0, 10px, 0);\n    }\n    90% {\n      transform: translate3d(0, -5px, 0);\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__bounceOutUp {\n    20% {\n      transform: translate3d(0, -10px, 0);\n    }\n    40%, 45% {\n      opacity: 1;\n      transform: translate3d(0, 20px, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(0, -2000px, 0);\n    }\n  }\n  @keyframes Toastify__bounceInDown {\n    from, 60%, 75%, 90%, to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n    }\n    0% {\n      opacity: 0;\n      transform: translate3d(0, -3000px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, 25px, 0);\n    }\n    75% {\n      transform: translate3d(0, -10px, 0);\n    }\n    90% {\n      transform: translate3d(0, 5px, 0);\n    }\n    to {\n      transform: none;\n    }\n  }\n  @keyframes Toastify__bounceOutDown {\n    20% {\n      transform: translate3d(0, 10px, 0);\n    }\n    40%, 45% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    to {\n      opacity: 0;\n      transform: translate3d(0, 2000px, 0);\n    }\n  }\n  .Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {\n    animation-name: Toastify__bounceInLeft;\n  }\n  .Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {\n    animation-name: Toastify__bounceInRight;\n  }\n  .Toastify__bounce-enter--top-center {\n    animation-name: Toastify__bounceInDown;\n  }\n  .Toastify__bounce-enter--bottom-center {\n    animation-name: Toastify__bounceInUp;\n  }\n\n  .Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {\n    animation-name: Toastify__bounceOutLeft;\n  }\n  .Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {\n    animation-name: Toastify__bounceOutRight;\n  }\n  .Toastify__bounce-exit--top-center {\n    animation-name: Toastify__bounceOutUp;\n  }\n  .Toastify__bounce-exit--bottom-center {\n    animation-name: Toastify__bounceOutDown;\n  }\n\n  @keyframes Toastify__zoomIn {\n    from {\n      opacity: 0;\n      transform: scale3d(0.3, 0.3, 0.3);\n    }\n    50% {\n      opacity: 1;\n    }\n  }\n  @keyframes Toastify__zoomOut {\n    from {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0;\n      transform: scale3d(0.3, 0.3, 0.3);\n    }\n    to {\n      opacity: 0;\n    }\n  }\n  .Toastify__zoom-enter {\n    animation-name: Toastify__zoomIn;\n  }\n\n  .Toastify__zoom-exit {\n    animation-name: Toastify__zoomOut;\n  }\n\n  @keyframes Toastify__flipIn {\n    from {\n      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n      animation-timing-function: ease-in;\n      opacity: 0;\n    }\n    40% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n      animation-timing-function: ease-in;\n    }\n    60% {\n      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n      opacity: 1;\n    }\n    80% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n    }\n    to {\n      transform: perspective(400px);\n    }\n  }\n  @keyframes Toastify__flipOut {\n    from {\n      transform: perspective(400px);\n    }\n    30% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n      opacity: 1;\n    }\n    to {\n      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n      opacity: 0;\n    }\n  }\n  .Toastify__flip-enter {\n    animation-name: Toastify__flipIn;\n  }\n\n  .Toastify__flip-exit {\n    animation-name: Toastify__flipOut;\n  }\n\n  @keyframes Toastify__slideInRight {\n    from {\n      transform: translate3d(110%, 0, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideInLeft {\n    from {\n      transform: translate3d(-110%, 0, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideInUp {\n    from {\n      transform: translate3d(0, 110%, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideInDown {\n    from {\n      transform: translate3d(0, -110%, 0);\n      visibility: visible;\n    }\n    to {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideOutRight {\n    from {\n      transform: translate3d(0, 0, 0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(110%, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideOutLeft {\n    from {\n      transform: translate3d(0, 0, 0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(-110%, 0, 0);\n    }\n  }\n  @keyframes Toastify__slideOutDown {\n    from {\n      transform: translate3d(0, 0, 0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, 500px, 0);\n    }\n  }\n  @keyframes Toastify__slideOutUp {\n    from {\n      transform: translate3d(0, 0, 0);\n    }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, -500px, 0);\n    }\n  }\n  .Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {\n    animation-name: Toastify__slideInLeft;\n  }\n  .Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {\n    animation-name: Toastify__slideInRight;\n  }\n  .Toastify__slide-enter--top-center {\n    animation-name: Toastify__slideInDown;\n  }\n  .Toastify__slide-enter--bottom-center {\n    animation-name: Toastify__slideInUp;\n  }\n\n  .Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {\n    animation-name: Toastify__slideOutLeft;\n  }\n  .Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {\n    animation-name: Toastify__slideOutRight;\n  }\n  .Toastify__slide-exit--top-center {\n    animation-name: Toastify__slideOutUp;\n  }\n  .Toastify__slide-exit--bottom-center {\n    animation-name: Toastify__slideOutDown;\n  }\n\n  /*# sourceMappingURL=ReactToastify.css.map */\n\n.Toastify__toast--info {\n    background: #8560FF;\n    color: #ffffff;\n}\n.Toastify__toast--success {\n    background: #41C6A2;\n}\n.Toastify__toast--warning {\n    background: #F7C76C;\n}\n.Toastify__toast--error {\n    background: #FF6969;\n}\n\n\n\n.loadingPage{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 25%;\n}\n\n.versioning {\n  position: absolute;\n  font-size: 8px;\n  right: 0;\n  color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
